<template>
  <v-container fluid class="px-6 py-6">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-card class="pa-4" width="100%" outlined>
          <h3 class="text-h5 font-weight-bold mb-4">Complete Your Profile</h3>
          <form @submit.prevent="handleSubmit">
            <v-row>
              <v-col cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                  >First Name</label
                >
                <v-text-field
                  v-model="form.firstName"
                  outlined
                  dense
                  required
                  placeholder="Enter your first name"
                  prepend-inner-icon="mdi-account"
                  class="
                    font-size-input
                    placeholder-lighter
                    text-light-input
                    border border-radius-md
                    mt-2
                  "
                  hide-details="auto"
                  width="100%"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Last Name</label
                >
                <v-text-field
                  v-model="form.lastName"
                  outlined
                  dense
                  required
                  placeholder="Enter your last name"
                  prepend-inner-icon="mdi-account"
                  class="
                    font-size-input
                    placeholder-lighter
                    text-light-input
                    border border-radius-md
                    mt-2
                  "
                  hide-details="auto"
                  width="100%"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Password</label
                >
                <v-text-field
                  v-model="form.password"
                  outlined
                  dense
                  required
                  type="password"
                  placeholder="Enter your password"
                  prepend-inner-icon="mdi-lock"
                  class="
                    font-size-input
                    placeholder-lighter
                    text-light-input
                    border border-radius-md
                    mt-2
                  "
                  hide-details="auto"
                  width="100%"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-alert v-if="error" type="error" dense class="mt-4">
              {{ error }}
            </v-alert>

            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                dark
                width="100%"
                :loading="loading"
                type="submit"
              >
                Complete Registration
              </v-btn>
            </div>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getAuth, confirmPasswordReset, updateProfile } from "firebase/auth";
import { updateSingleObjectToFirebase } from "@/services/firebase-helpers";

export default {
  name: "OnboardUser",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        password: "",
      },
      loading: false,
      error: null,
      companyId: null,
      email: null,
      uid: null,
    };
  },
  created() {
    // Get email, companyId, and uid from URL
    this.email = this.$route.query.email;
    this.companyId = this.$route.query.companyId;
    this.uid = this.$route.query.uid;

    if (!this.email || !this.companyId || !this.uid) {
      this.error = "Invalid invitation link";
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      this.error = null;

      try {
        const auth = getAuth();
        const actionCode = this.$route.query.oobCode;

        if (!actionCode || !this.companyId || !this.email || !this.uid) {
          throw new Error("Invalid invitation link");
        }

        // Reset password and get user
        await confirmPasswordReset(auth, actionCode, this.form.password);
        const user = auth.currentUser;

        // Update user data in Realtime DB
        const userData = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.email,
          companyId: this.companyId,
          createdAt: new Date().toISOString(),
          ...user,
        };

        await updateSingleObjectToFirebase(userData, "users", this.uid);

        // Redirect to dashboard
        this.$router.push("/locations");
      } catch (error) {
        console.error("Error during onboarding:", error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
